export { default as ManageDomainSettings } from './domain-settings.svelte';
export { default as Permission } from './permission.svelte';

export const enabledValue = 'label.ENABLED_VALUE';
export const disabledValue = 'label.DISABLED_VALUE';
